/**
 * JSONEditor page
 *
 * @author Agbonaye Osaru - osaru@sarutech.com
 */
import { Component, Injector, Input, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { NavController, Platform, ActionSheetController, ModalController, NavParams } from '@ionic/angular';
declare let JSONEditor: any;
@Component({
  selector: 'page-jsoneditor',
  templateUrl: 'jsoneditor.html',
  styleUrls: ['jsoneditor.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class JsonEditorPage {
  navParams: any = {};
  @Input() ispage: boolean = true;
  @Input() edit: boolean = true;
  container: any;
  @Input() options = {};
  editor: any;
  divID = (Math.random() + 1).toString(36).substring(7); //uniq id of the div; it is done dynamically this way so as to enable multiple ones for conflict manager document.getElementbyID
  // set json
  @Input() initialJson = {};
  updatedJson: any;

  constructor(injector: Injector, public actionSheetCtrl: ActionSheetController, public router: Router, public modalCtrl: ModalController, public platform: Platform, public navCtrl: NavController) {
    let navParams2: any = {};
    if (router.url != '/AddEntityPage' && router.url != '/RestorePage') {
      navParams2 = injector.get(NavParams);
    }
    this.navParams = this.router.getCurrentNavigation() && this.router.getCurrentNavigation().extras.state != undefined ? this.router.getCurrentNavigation().extras.state : navParams2.data;
    this.initialJson = this.navParams ? this.navParams['entity'] : {};
    if (this.navParams && this.navParams['options']) {
      this.options = this.navParams['options'];
    }
    if (this.navParams && this.navParams['edit'] != undefined) {
      this.edit = this.navParams['edit'];
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    Object.keys(changes).map((key) => {
      this[key] = changes[key].currentValue;
    });
    setTimeout(() => {
      //allow time for template to load so this.container does not return null;
      if (this.editor == undefined) {
        this.container = document.getElementById(this.divID);
        // empty container before creating new editor
        this.container.innerHTML = '';
        this.editor = new JSONEditor(
          this.container,
          this.edit
            ? this.options
            : {
                mode: 'view',
              }
        );
      }
      this.editor.set(this.initialJson);
    }, 500);
  }

  ngOnInit() {
    if (this.navParams?.entity) {
      setTimeout(() => {
        this.container = document.getElementById(this.divID);
        this.editor = new JSONEditor(this.container, this.options);
        this.editor.set(this.initialJson);
      }, 500);
    }
  }

  save() {
    this.updatedJson = this.editor.get();
    this.modalCtrl.dismiss(this.updatedJson);
  }

  cancel() {
    //cancel action
    this.modalCtrl.dismiss();
  }
}
